import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Servidor {
  id: string;
  nome: string;
}

export const useServidores = () => {
  return useQuery({
    queryKey: ["servidores"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("servidores")
        .select("id, nome")
        .eq("ativo", true)
        .order("nome");
      if (error) throw error;
      return data as Servidor[];
    },
  });
};
